import * as React from 'react';
import { default as moment, Moment } from 'moment-timezone';
import { styles } from './styles';

const isSameMonthAndDate = (isSameMonth: boolean, currentDate: number) => {
  return (nextDate: number) => {
    return isSameMonth && currentDate === nextDate;
  };
};

const isDateBeforeCurrentMonth = (isInitialWeek: boolean, date: number, startOfCurrentMonthOffset: number) => {
  return isInitialWeek && date < startOfCurrentMonthOffset;
};

const isDateAfterCurrentMonth = (date: number, daysInMonth: number) => {
  return date > daysInMonth;
};

const buildDay = (index: number, date: Moment | null, isSelected: boolean) => {
  return (
    <div key={`${index}-${date ? date.date() : null}`} className={styles.dateRules(isSelected)}>
      {date ? <button data-date={date.unix() * 1000}>{date.date()}</button> : null}
    </div>
  );
};

const buildWeek = (index: number, weekDays: Array<JSX.Element>) => {
  return (
    <div key={`${index}`} className={styles.week}>
      {weekDays}
    </div>
  );
};

const buildMonth = (currentSelectionMoment: Moment) => {
  const currentSelectionDate = currentSelectionMoment.date();
  const currentSelectionMomentClone = currentSelectionMoment.clone().startOf('month');

  const startOfCurrentMonthOffset = currentSelectionMomentClone.weekday() + 1;
  const daysInCurrentMonth = currentSelectionMomentClone.daysInMonth();
  const numWeeksInCurrentMonth = Math.ceil((currentSelectionMoment.daysInMonth() + startOfCurrentMonthOffset) / 7);

  let currentDate = 1;
  const month: any = [];

  // TODO: We can change the following line to reflect the actual selection moment
  const isDateSelected = isSameMonthAndDate(true, currentSelectionDate);

  for (let weekIndex = 0; weekIndex < numWeeksInCurrentMonth; weekIndex++) {
    const week: any = [];
    const isInitialWeek = weekIndex === 0;
    for (let dayIndex = 1; dayIndex < 8; dayIndex++) {
      if (
        isDateBeforeCurrentMonth(isInitialWeek, dayIndex, startOfCurrentMonthOffset) ||
        isDateAfterCurrentMonth(currentDate, daysInCurrentMonth)
      ) {
        week.push(buildDay(dayIndex, null, false));
      } else {
        week.push(buildDay(dayIndex, currentSelectionMomentClone, isDateSelected(currentSelectionMomentClone.date())));
        currentSelectionMomentClone.add(1, 'days');
        currentDate++;
      }
    }
    month.push(buildWeek(weekIndex, week));
  }

  return month;
};

const buildWeekdayHeaders = () => {
  return (
    <div className={styles.weekdayContainerRules}>
      {moment.weekdays().map(weekday => {
        return (
          <div key={weekday} className={styles.weekdayRules}>
            {weekday.slice(0, 2)}
          </div>
        );
      })}
    </div>
  );
};

export interface Props {
  handleClick: (e: any) => any;
  currentSelectionMoment: Moment;
}

const Calendar: React.SFC<Props> = ({ handleClick, currentSelectionMoment }) => {
  return (
    <div className={styles.calendarContainer} onClick={handleClick}>
      {buildWeekdayHeaders()}
      <div className={styles.monthContainerRules}>{buildMonth(currentSelectionMoment)}</div>
    </div>
  );
};

export { Calendar };
